export const svgIds = { cabelas: 'cabelasSvg' } as const;
export const styleClassNames = { cabelas: 'cabelas-style' } as const;
export const backgroundColor = { cabelas: '#021D41' } as const;
// eslint-disable-next-line max-len
export const passwordComplexityRequirements = 'Password must be eight or more characters, contain at least one upper and one lower case letter, at least one number, and at least one special character (ex. @)';
export const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?(?:\p{S}|\p{P})).{8,}$/u;

export enum QueryParams {
  CrossBrand = 'crossBrand',
  VerificationCode = 'verificationCode',
  RedirectTo = 'redirectTo',
  RedirectToAlt = 'redirect_to',
  RedirectMemberTo = 'redirectMemberTo',
  RedirectNonMemberTo = 'redirectNonMemberTo',
  IgnoreEmbed = 'ignoreEmbedAndRenderFull',
  SecretToken = 'secretToken'
}
